export const ID_LAMINATO = 3;
export const ID_MENSOLA_PERSONALIZZATO = 2;
export const ID_BATTISCOPA_PERSONALIZZATO = 3;
export const ID_VANO_PERSONALIZZATO = 3;
export const ID_VANO_SPIGOLO_VIVO = 2;

export const ID_VETRO_TEXTURE = 24;
export const ID_VETRO_MISTO = 38;
// Sprint 10-2026: Filo Muro / Obliquo / Complanare non sono piu' checkbox sull'ordine
// ma sistemi di apertura dedicati (V62). Gli id sono allineati a Constants.DBData lato BE.
export const ID_FILO_MURO_SCORREVOLE: number[] = [42, 43];
export const ID_FILO_MURO_BATTENTE: number[] = [38, 39];
export const ID_OBLIQUO: number[] = [40, 41];
export const ID_COMPLANARE: number[] = [34, 35];

// Telai introdotti con V60: sostituiscono la vecchia scelta testuale "listellare"/"alluminio".
export const ID_TELAIO_FILO_MURO_LISTELLARE = 15;
export const ID_TELAIO_FILO_MURO_ALLUMINIO = 16;

export const SEGNALATORI_PATH = "gruppi";
export const MY_ANGULAR_DATE_FORMAT = "DD/MM/YYYY";
export const ITALY_NATIONAL_ID = 1;
export const BODY_EMAIL_DEFAULT = "Egregio CLIENTE,\n\n\n\nIN ALLEGATO QUANTO DA LEI RICHIESTO.\n\n\n\nRimaniamo a disposizione per eventuali chiarimenti,\n\n\n\nCordiali Saluti\n\nGP Porte srl";
export const REGEX_MAIL = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const ADMIN_VOICES: string[] = [
  "UTENTI",
  "CLIENTI",
  "GRUPPI",
  "PREVENTIVI",
  "PREVENTIVI X",
  "PREVENTIVI GENERALI",
  "ORDINI",
  "CARICO",
  "PRODUZIONE",
  "AUTISTI",
  "PERCENTUALI",
  "MAPPE",
  "IMPOSTAZIONI",
  "CAMBIO PREZZI",
];
export const ADMIN_ICONS: string[] = [
  "account_circle",
  "shopping_bag",
  "shopping_bag",
  "account_circle",
  "description",
  "description",
  "description",
  "shopping_cart",
  "local_shipping",
  "local_shipping",
  "calculate",
  "place",
  "settings",
  "euro",
];

export const VENDITORE_VOICES: string[] = [
  "PRODUZIONE",
  "CLIENTI",
  "GRUPPI",
  "PREVENTIVI",
  "PREVENTIVI X",
  "PREVENTIVI GENERALI",
  "ORDINI",
  "CARICO",
  "MAPPE",
];

export const VENDITORE_ICONS: string[] = [
  "shopping_bag",
  "shopping_bag",
  "account_circle",
  "description",
  "description",
  "description",
  "shopping_cart",
  "local_shipping",
  "place",
];

export const ADMINISTRATION_VOICES: string[] = [
  "PRODUZIONE",
  "CLIENTI",
  "GRUPPI",
  "PREVENTIVI",
  "PREVENTIVI X",
  "PREVENTIVI GENERALI",
  "ORDINI",
  "AUTISTI",
  "CARICO",
  "MAPPE",
  "IMPOSTAZIONI",
  "CAMBIO PREZZI",
];

export const ADMINISTRATION_ICONS: string[] = [
  "shopping_bag",
  "shopping_bag",
  "account_circle",
  "description",
  "description",
  "description",
  "shopping_cart",
  "local_shipping",
  "local_shipping",
  "place",
  "settings",
  "euro",
];

export const ADMIN_VOICES_IMPOSTAZIONI: string[] = [
  "TEMPLATE",
  "CLAUSOLE DEL PREVENTIVO",
  "GRUPPI PERSONE GIURIDICHE",
  "COORDINATE BANCARIE",
  "METODI DI PAGAMENTO",
  "LISTINO",
  "TRASPORTO",
];

export const ADMIN_PATH_IMPOSTAZIONI: string[] = [
  "TEMPLATE",
  "CLAUSOLE-DEL-PREVENTIVO",
  "GRUPPI-PERSONE-GIURIDICHE",
  "COORDINATE-BANCARIE",
  "METODI-PAGAMENTO",
  "LISTINO",
  "TRASPORTO",
];

export const ADMIN_ICONS_IMPOSTAZIONI: string[] = [
  "upload_file",
  "text_snippet",
  "group",
  "credit_card",
  "credit_card",
  "euro",
  "inbox"
];
export const PRODUZIONE_VOICES: string[] = [
  "PRODUZIONE",
];
export const PRODUZIONE_ICONS: string[] = [
  "account_circle",
  "shopping_bag",
  "shopping_bag",
  "account_circle",
  "description",
  "description",
  "description",
  "shopping_cart",
  "local_shipping",
  "local_shipping",
  "calculate",
  "place",
  "settings",
];
export const TIPI_ORDINE = {
  MENSOLE: "MENSOLE",
  PORTE_INTERNO: "PORTE_INTERNO",
  BATTISCOPA: "BATTISCOPA",
  VANO: "VANOPASSAGGIO",
  SPORTELLINO: "SPORTELLINO",
  PORTE: "PORTE",
  PORTE_BLINDATO: "BLINDATO",
  ACCESSORI_BLINDATO: "ACCESSORI_BLINDATO",
  INTERNO: "INTERNO",
  LUCERNARIO: "LUCERNARIO",
  SFUSO: "SFUSO"
};

export const TIPOLOGIA_ANTE_LUCERNARIO_VETRO = "VETRO";

export const OPERAZIONE = {
  ALTRO_MODELLO_BATTISCOPA: "ALTRO_MODELLO_BATTISCOPA",
  ALTRO_MODELLO_PORTA_INTERNO: "ALTRO_MODELLO_PORTA_INTERNO",
  ALTRO_MODELLO_MENSOLA: "ALTRO_MODELLO_MENSOLA",
  ALTRO_MODELLO_VANO: "ALTRO_MODELLO_VANO",
  ALTRO_MODELLO_SPORTELLINO: "ALTRO_MODELLO_SPORTELLINO",
  ALTRO_MODELLO_PORTA_BLINDATO: "ALTRO_MODELLO_PORTA_BLINDATO",
  ALTRO_ACCESSORI: "ALTRO_ACCESSORI",
  ALTRO_LUCERNARIO: "ALTRO_LUCERNARIO",
  ALTRO_MODELLO_SFUSO: "ALTRO_MODELLO_SFUSO",
  ANNULLA: "ANNULLA",
};
export const ROLES = {
  APPADMIN: "app-admin",
  APPAMMINISTRAZIONE: "app-amministrazione",
  APPPRODUZIONE: "app-produzione",
  ADMIN: "admin",
  AMMINISTRAZIONE: "amministrazione",
  VENDITORE: "app-venditore",
  VENDITORE_EI: "app-venditore-ei",

};

export type GENDER = "MAN" | "FEMALE";

export const GENDER = {
  MAN: "MASCHIO" as GENDER,
  FEMALE: "FEMMINA" as GENDER,
};

export const VOICES_TIPI_PORTE_PREVENTIVO: string[] = [
  "MENSOLE ",
  "PORTE INTERNO",
  "PORTE BLINDATO",
  "PORTE METALLICHE",
  "PORTE EI",
  "BATTISCOPA ",
  "VANO PASSAGGIO",
  "SPORTELLINO",
  "ACCESSORI BLINDATO",
  "LUCERNARIO",
  "SFUSO"
];

export const ICONS_TIPI_PORTE_PREVENTIVO_PATH: string[] = [
  "assets/images/preventivi/MENSOLE[1].png",
  "assets/images/preventivi/PORTE-INTERNO[1].png",
  "assets/images/preventivi/BLINDATO[1].png",
  "assets/images/preventivi/METALLICHE[1].png",
  "assets/images/preventivi/PORTE-EI[1].png",
  "assets/images/preventivi/BATTISCOPA[1].png",
  "assets/images/preventivi/VANO-PASSAGGIO[1].png",
  "assets/images/preventivi/SPORTELLINI[1].png",
  "assets/images/preventivi/ACCESSORI[1].png",
  "assets/images/preventivi/LUCERNARIO[1].png",
  "assets/images/preventivi/SFUSO[1].png"
];
export const ICONS_TIPI_PORTE_PREVENTIVO_HOVER_PATH: string[] = [
  "assets/images/preventivi/MENSOLE.png",
  "assets/images/preventivi/PORTE-INTERNO.png",
  "assets/images/preventivi/BLINDATO.png",
  "assets/images/preventivi/METALLICHE.png",
  "assets/images/preventivi/PORTE-EI.png",
  "assets/images/preventivi/BATTISCOPA.png",
  "assets/images/preventivi/VANO-PASSAGGIO.png",
  "assets/images/preventivi/SPORTELLINI.png",
  "assets/images/preventivi/ACCESSORI.png",
  "assets/images/preventivi/LUCERNARIO.png",
  "assets/images/preventivi/SFUSO.png"
];

export class PREVENTIVO {
  static CONFERMATO = "In attesa di conferma";
  static NON_CONFERMATO = "Preventivo";
  static PREVENTIVO2 = "Preventivo2";
  static CHIUSO = "Prev. Generale";
  static SCADUTO = "Scaduto";
  static ORDINE = "Ordine";
}

export const LINEA_ID = {
  CLASSIC: 36,
  EVOLUTION: 37,
  FASHION: 45,
  MEEETING_PLUS: 46,
  MEEETING_BASIC: 47,
};

export const CAT_ID = {
  LEGNO: 1,
  LACCATO: 2,
  LAMINATO: 3,
};

export function sortListByName(list: any[]): any[] {
  return list.sort((a, b) => {
    const nameA = a.name;
    const nameB = b.name;
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
  });
}

export function sortListById(list: any[]): any[] {
  return list.sort((a, b) => {
    const idA = a.id;
    const idB = b.id;
    return idA < idB ? -1 : idA > idB ? 1 : 0;
  });
}

export function sortListByCode(list: any[]): any[] {
  return list.sort((a, b) => {
    const codeA = a.code;
    const codeB = b.code;
    return codeA < codeB ? -1 : codeA > codeB ? 1 : 0;
  });
}

export function sortListAlphabetically(list: any[]): any[] {
  return list.sort((a, b) => {
    return a < b ? -1 : a > b ? 1 : 0;
  });
}

export enum MANDATORY_FIELD_LUCERNARIO {
    CATEGORIA = "categoriaId",
    ESSENZA = "essenza",
    TELAIO = "telaioId",
    MOSTRINE_AVANTI = "mostrinaAvantiId",
    MOSTRINE_DIETRO = "mostrinaDietroId",
    ALTEZZA = "altezza",
    LARGHEZZA = "larghezza",
    SPESSORE_MURO = "spessoreConfigurazione",
    TIPOLOGIA_ANTA = "tipologiaAnte",
    QUANTITA = "quantity"
}

export enum DIMENSION_FIELD_ERRORS_LUCERNARIO {
    ALTEZZA = 'altezza_not_valid',
    LARGHEZZA = 'larghezza_not_valid'
}

export enum MANDATORY_FIELD_SOPRALUCE {
    TIPOLOGIA_ANTA = "tipologiaAnte",
    TIPOLOGIA_VETRO = "tipologiaVetro",
    COLORE_VETRO = "coloreVetro",
    LAVORAZIONE = "lavorazioneDecoro",
    COLORE_DECORO = "coloreDecoro",
    DECORO = "decoro",
    NOTE_DECORO = "noteDecoro",
    CODICE_DECORO = "codiceDecoro",
    CODICE_DECORO_SERIGRAFATO = "codiceDecoroSerigrato38",
    NOTE_DECORO_SERIGRAFATO = "noteSerigrafato"
}
